<template>
    <div>
        <v-simple-table :style="'background-color:' + getPeriodColors() + ';color:' + getTextColor()">
            <tr v-for="day in data.opening_days">
                <td>
                    {{ daysOfWeek[day.day_of_week] }}
                </td>
                <td>
                    <div class="py-2">
                        <div v-if="day.closed || (day.closed && day.opening_hours && day.opening_hours.length === 0)">
                            Fermé
                        </div>
                        <div
                          v-else-if="day.opening_hours && day.opening_hours.length > 0 && day.opening_hours[0].open !== null"
                        >
                            <div class="d-flex align-items-center">
                                {{ formatHour(day.opening_hours[0].open) }}
                                <div class="mr-1 ml-1">-</div>
                                {{ formatHour(day.opening_hours[0].close) }}
                            </div>

                            <div class="d-flex align-items-center"
                                 v-if="day.opening_hours &&
                                       day.opening_hours.length > 1 &&
                                       day.opening_hours[1].open !== null &&
                                       day.opening_hours[1].close !== null">
                                {{ formatHour(day.opening_hours[1].open) }}
                                <div class="mr-1 ml-1">-</div>
                                {{ formatHour(day.opening_hours[1].close) }}
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </v-simple-table>
    </div>
</template>

<script>
export default {
    name: "VtOpeningDiffCard",
    props: ["openingDiff", "data", 'isNewPeriod',],
    data() {
        return {
            daysOfWeek: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
        }
    },
    methods: {
        getPeriodColors() {
            if (this.isNewPeriod) {
                return "#FFF3E0"
            } else {
                return '#f8f9fa'
            }
        },
        getTextColor() {
            if (this.isNewPeriod) {
                return "#FF9800"
            } else {
                return '#000000'
            }
        },
        formatHour(hour) {
            let splited = hour.split(":")
            hour = splited[0] + ":" + splited[1]
            return hour
        },
    },
}
</script>